import React from 'react';
import { CARD_TYPES } from '@nike/ciclp-redux-app';
import { TextStyled } from '@nike/nike-design-system-components';
import { Heading } from '@nike/web-a11y-ariakit-react';
import ImageSlide from './slideComponents/imageSlide';
import VideoSlide from './slideComponents/videoSlide';
import { CardLink } from '../cardLink';
import styles from './slideshowSlide.styl';
import { gallerySlideShape } from '../../shapes';
import { createMarkup } from '../../helpers/text';

const getSlideComponent = slide => {
  switch (slide?.containerType) {
    case CARD_TYPES.VIDEO:
      return VideoSlide;
    case CARD_TYPES.IMAGE:
      return ImageSlide;
    default:
      return ImageSlide;
  }
};

const SlideshowSlide = ({
  analyticsItemId,
  sectionHeadlineTitle,
  cardId,
  isVideoCard,
  cardLinkMemberOnly,
  ...slide
}) => {
  const Slide = getSlideComponent(slide);
  const caption = (
    <figcaption className={styles.slideTextWrapper}>
      {slide.titleProps?.text && (
        <TextStyled
          Component={Heading}
          data-qa="title"
          appearance="body2"
          className={styles.slideTitle}
          dangerouslySetInnerHTML={createMarkup(slide.titleProps?.text)}
          color={
            slide.titleProps.isTextColorSet
              ? slide.titleProps.textColor
              : 'secondary'
          }
        />
      )}
    </figcaption>
  );

  return (
    <figure
      data-analytics-placement-id={analyticsItemId}
      data-analytics-has-landmark="true"
      data-qa="carousel-slideshow-item"
      data-is-carousel-content={slide?.isInCarousel}
      data-item-count={slide?.totalSlides}
    >
      {slide.counter}
      <Slide {...slide} caption={caption} />
      {slide?.cardLinkUrl && (
        <CardLink
          memberOnly={cardLinkMemberOnly}
          draggable={false}
          actionId={slide.cardLinkId}
          destinationUrl={slide.cardLinkUrl}
          openInNewTab={slide.openInNewTab}
          renderAs="a"
          ariaLabel={slide.titleProps?.text}
        />
      )}
    </figure>
  );
};

SlideshowSlide.propTypes = gallerySlideShape;

export default SlideshowSlide;
